import React, { useState, forwardRef, useEffect } from "react";

import { InputTextarea } from "primereact/inputtextarea";
import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import studentsAPI from "../../../../services/students";

const UpdateRegistrationWaitingDetailsModal = forwardRef((props, ref) => {
  //
  const [registrationDetails, setRegistrationDetails] = useState("");
  //
  useEffect(() => {
    setRegistrationDetails(props?.student?.on_waiting_list_details);
  }, [props]);

  //
  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Détails sur la mise en liste d'attente"
        serviceAPI={studentsAPI}
        id={props?.student?.id}
        schoolId={props?.schoolId}
        trainingId={props?.trainingId}
        data={{
          on_waiting_list_details: registrationDetails,
        }}
      >
        <InputTextarea value={registrationDetails || ""} className="w-full" onChange={(e) => {
          setRegistrationDetails(e.target.value);
        }} rows={5} autoResize />
      </MeaUpdateModal>
    </>
  );
});

export default UpdateRegistrationWaitingDetailsModal;
